import { SettingValue } from "@/types";
import { usePage } from "@inertiajs/vue3";
import find from "lodash/find";
import { ref } from "vue";

export function useSetting(_props?: any) {
    const props = ref(_props ?? usePage().props);

    const getSetting = function (key: string, _default: any = null) {
        const siteSetting: SettingValue | undefined = find(
            props.value?.site?.settings ?? [],
            (val: SettingValue) => val.setting.key == key
        );

        if (siteSetting)
            return siteSetting.value ?? siteSetting.setting.default ?? _default;

        return _default;
    };

    return { getSetting };
}
